const data = [
	{
		exprience: `Currently working as Professor & Head of Department, Rajarshi Shahu College of 
		Engineering, Tathawade, Pune-33 ( 18th October 2021 to till date )`,
	},
	{
		exprience: `Worked as Associate Professor & Head of Department in JSPM Narhe Technical 
		Campus, Narhe, Pune-41 (10th January 2019 to 31st October 2021)`,
	},
	{
		exprience: `Worked as a Dean / Head (second shift) & Assistant Professor (UGC Approved) in 
		computer Engineering department, Sinhgad Institute of Technology & Science, Narhe, 
		Pune-411041, (1
		st
		 January 2015 to 9
		th January 2019)
		`,
	},
	{
		exprience: `Worked as an Assistant Professor (UGC Approved) at Sinhgad Institute of Technology 
		& Science, Narhe, Pune-411041, ( 1
		st January 2010 to 31st December 2015)`,
	},
	{
		exprience: `Worked as a Lecturer (UGC Approved) & Sr. Lecturer at JSPM’S Rajarshi Shahu College 
		of Engineering, Tathawade, Pune-41037, ( 1
		st January 2005 to 31st December 2009).
		`,
	},
	{
		exprience: `Worked as a Lecturer (UGC Approved) at SSBT College of Engineering & Technology , 
		Jalgaon, (1
		st July 2003 to 31st December 2004).`,
	},
	{
		exprience: `Worked as a Lecturer at Institute of Management & Research, Jalgaon, ( 1
			st July 2000 to 
			30th June 2003).
			`,
	},
];
export default data;
